import { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { useLocation } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { Grid,Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CandidateHeader from '../Candidate/Candidate Navbar/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faChevronRight , faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import './Exam.css'
import AdSense from 'react-adsense-ads';
import GoogleAds from "./Google_Adsense";
import ExamNavbar from "./ExamNavbar";
import NodataModal from './NoDataModal'
import ShowAnswer from "./Show_Answer";
import LoadingSpinner from '../Utils/LoadingSpinner'
import timeUp from '../../assets/exam/timeUp.png'



export default function StartExam() {
    // =========== location data ===========
    const location = useLocation();
    const exam = location.state.exam;
    const numQues = location.state.numQues;
    let navigate = useNavigate();
    const [loader,setLoader] = useState(true);
 

    // =========== Index and questions ===========
    const [queslength, setQueslength] = useState(0);
    const [questions, getQuestions] = useState([
        {
            question: "",
            options: [""],
            answer: "",
            explain: ""
        }
    ]);
    const [questionIndex, setQuestionIndex] = useState(0);

    // =========== score and user answers ===========
    const [score, setScore] = useState(0);
    const [radioValue, setRadioValue] = useState({});

    // =========== popups, answers, restart ===========
    const [show, setShow] = useState(false);
    const [showCard, setShowCard] = useState(true);

    // =========== countdown ===========
    const dataFetchedRef = useRef(false);
    var time;
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [timesup,setTimesUp] = useState(false);


    // function handleReload() {
    //     // Update state to trigger re-render
    //     navigate(0)
    //   }


    useEffect(() => {
        // ================================== api data =======================================
        axios.post("https://pl.aspireitacademy.com/selecte_exam", {
            language: exam.id,
            num: numQues
        }).then(res => {
            setLoader(false);
            getQuestions(res.data);
            if (((res.data).length) < numQues) {
                setQueslength(((res.data).length));
                time = ((res.data).length * 60);
            }
            else {
                setQueslength(numQues);
                time = (numQues * 60);
            }
        })


        // timer
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        setInterval(updateCountdown, 1000);
    }, [])

    //advertisement
    const ads_1 = "https://thumbs.dreamstime.com/z/black-friday-sale-vertical-web-banner-ad-ready-sites-press-as-discount-advertisement-flyer-contains-103627201.jpg"
    const ads_2 = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT0mmuGGFUDGJmnJvkbrUAFCTAbAR_w00idug&usqp=CAU"
    const ads_3 = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQEgZzz158diCywk1gMjvUzbYBY88vLMXrb0g&usqp=CAU";

    const onChange = (ev) => {
        setRadioValue({ ...radioValue, [ev.target.name]: ev.target.value });
    };


    function onClickSubmit() {
        var mark = 0
        for (let i = 0; i < questions.length; i++) {
            if (questions[i].answer == radioValue["question" + String(i + 1)]) {
                mark++;
                setScore(mark);
            }
        }
        setShow(true);
    };


    function updateCountdown() {
        setMinutes(Math.floor(time / 60));
        setSeconds(Math.floor(time % 60));
        if (time >= 0) {
            time = time - 1;
            if(time < 0){
                setTimesUp(true);
            }
        };
    };

return (
<section>
    <CandidateHeader />
    <ExamNavbar />
    { loader ? <LoadingSpinner />: 
    <>
    { questions.length < 1 ? <NodataModal /> :    
    <div className="container my-5 px-5">
            {show ?
        // ============================================ show result popup and answers ============================================
            <ShowAnswer questions={questions} exam={exam} score={score} queslength={queslength} />
            : 
        // ============================================ show questions ============================================
                                    
        <div className="exam-container">
        <div className="exam-card "  style={{ boxShadow: "0px 0px 3px 0px #c1c1c1" }}>
        <div className="exam-title-container" style={{backgroundColor:"#EEF2FF"}}>
            <div className="exam-title px-4 py-2  d-flex align-items-center justify-content-between"  style={{flexWrap: "wrap"}}  >
            <h3 className="text-capitalize">{exam.name}</h3>
            <p  className=" mb-0 exam-timer">Time Left: {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}</p>
            </div>
        </div>

        <div className="qstn-container p-4 ">
        {questions.map((item, index) => {
            return (
                <div className={`${index == questionIndex ? 'displaydiv' : 'hiddendiv'}`} key={index}>
                    <h6 className="my-2">Q{questionIndex + 1 + "/"+queslength+")" }{item.question}</h6>
                    <div>{
                        item.options.map((ops, index_ops) => {
                        
                            return (
                                <label className="form-check" key={index_ops}>
                                    <input
                                        key={index}
                                        type="radio"
                                    
                                        className="form-check-input"
                                        value={ops.id}
                                        name={"question" + String(index + 1)}  
                                        id={"question" + String(index + 1)}  
                                        onChange={(ev) => onChange(ev)}
                                    />
                                    <span className="form-check-label" htmlFor={ops} style={{overflowWrap: "break-word"}}>{ops.option}</span>
                                </label>
                            )
                        })
                    }</div>
                    {/* Next and PRevious button */}
                    <div className=" d-grid gap-2 d-flex justify-content-end">
                        { questionIndex === 0 ? null : 
                            < button onClick={() => { setQuestionIndex(questionIndex - 1) }} className="btn btn-primary me-2 exam-btn"> 
                            <FontAwesomeIcon  className="me-1" size="xs" icon={faChevronLeft} />
                            Previous </button>
                        }
                        { questions.length === questionIndex + 1 ? 
                            <button type='button' onClick={onClickSubmit} className="btn btn-success exam-btn">Submit</button> :
                            <button type='button' onClick={() => { setQuestionIndex(questionIndex + 1) }} className="btn btn-primary exam-btn">Next
                            <FontAwesomeIcon  className="ms-1" size="xs" icon={faChevronRight} />
                            </button>
                        }
                    </div>
                {/* Times up modal */}
                {
                    timesup ? <>
                    <Modal show={showCard} className="d-flex justify-content-center align-items-center">
                        <Modal.Body>
                            <div className='container text-center'>
                                <img src={timeUp} alt="time's up" width="150px" height="150px"/>
                                <h5>Time's up! Your exam has ended</h5>
                                <button type='button' onClick={onClickSubmit} className="mt-2 mx-5 btn btn-success exam-btn">Submit</button>
                            </div>
                        </Modal.Body>
                    </Modal>
                    </> : null
                }


                </div>
            )
        })}
        </div>


        </div>   
        </div>                             
            }
    </div>
    }   </> } 
</section>
    )
}